import { render, staticRenderFns } from "./IBSReal.vue?vue&type=template&id=ba53cf86&scoped=true"
import script from "./IBSReal.vue?vue&type=script&lang=js"
export * from "./IBSReal.vue?vue&type=script&lang=js"
import style0 from "./IBSReal.vue?vue&type=style&index=0&id=ba53cf86&prod&lang=scss&scoped=true"
import style1 from "./IBSReal.vue?vue&type=style&index=1&id=ba53cf86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba53cf86",
  null
  
)

export default component.exports